import { authenticate, authenticateAdmin } from '@connect-x-app/hybrid-data-access';
import { AuthenticatedUser, QueryKeys } from '@connect-x-app/shared-domain-models';
import { useQuery } from '@tanstack/react-query';

export const useGetAuthenticatedUser = (admin: boolean, options?: { enabled?: boolean }) =>
  useQuery<AuthenticatedUser>({
    enabled: options?.enabled ?? true,
    queryFn: admin ? authenticateAdmin : authenticate,
    queryKey: [QueryKeys.AUTHENTICATE],
  });
